import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationService, ToastType } from '../../../core/services/notification.service';

@Component({
  selector: 'app-toast-container',
  templateUrl: './toast-container.component.html',
  styleUrls: ['./toast-container.component.scss'],
  imports: [CommonModule],
  standalone: true
})
export class ToastContainerComponent {

  readonly notificationService = inject(NotificationService);

  // Classe CSS dérivée du type — create/update → success, error/server-error → error.
  classFor(type: ToastType): string {
    if (type === 'error' || type === 'admin-server-error' || type === 'user-server-error') {
      return 'toast--error';
    }
    if (type === 'delete') {
      return 'toast--warning';
    }
    return 'toast--success';
  }

  dismiss(id: number): void {
    this.notificationService.dismiss(id);
  }
}
